import { render, staticRenderFns } from "./DeptGrantStore.vue?vue&type=template&id=cf09894e&scoped=true&"
import script from "./DeptGrantStore.vue?vue&type=script&lang=js&"
export * from "./DeptGrantStore.vue?vue&type=script&lang=js&"
import style0 from "./DeptGrantStore.vue?vue&type=style&index=0&id=cf09894e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf09894e",
  null
  
)

export default component.exports